import { ComparisonOperator, ComparisonOperators, TypeFilterObject } from '../../models/Enum/FilterProperties';
import { Filter, AndFilter, FieldFilter, OrFilter } from './filter';

export function getFilterPredicate<T>(parameters:  Filter): (value: T) => unknown{
    return (value: T) => matchFilterType<T>(parameters, value);
}

export function getAndFilterPredicate<T>(parameters:  AndFilter, value: T): any{

    return matchFilterType(parameters.left as Filter, value) && matchFilterType(parameters.right as Filter,value);
}

export function getOrFilterPredicate<T>(parameters:  AndFilter, value: T): any{
    return matchFilterType(parameters.left as Filter, value) || matchFilterType(parameters.right as Filter,value);
}

export function getFieldFilterPredicate<T>(parameters:  FieldFilter,value: T): any {
    if(parameters.field && toLowerCaseFirstLetter(parameters.field) in value && parameters.operator)
    {
        return  getPredicateValue(parameters.operator,value[toLowerCaseFirstLetter(parameters.field) as keyof T],parameters.value);
    }
    return false;
}

function toLowerCaseFirstLetter(str: string) {
    return str.charAt(0).toLowerCase() + str.slice(1);
}
  
function matchFilterType<T>(parameters:  Filter, value:T ){
    switch(parameters.type){
        case TypeFilterObject.And:
            return getAndFilterPredicate<T>(parameters as AndFilter, value);
        case TypeFilterObject.Or:
            return getOrFilterPredicate<T>(parameters as OrFilter, value);
        case TypeFilterObject.Field :
            return getFieldFilterPredicate<T>(parameters as FieldFilter, value);
        case TypeFilterObject.date:
                return getFieldFilterPredicate<T>(parameters as FieldFilter, value);
        default:
            return false;
    }
}

function getPredicateValue(operator: ComparisonOperator, valueLeft: any,valueRight : any){
    switch(operator)
    {
        case ComparisonOperators.Equal:
            return valueLeft === valueRight;
        case ComparisonOperators.Contains:
            return (valueLeft as string | Array<any>).includes(valueRight);
        case ComparisonOperators.GreaterThan:
            return valueLeft  > valueRight;
        case ComparisonOperators.GreaterThanOrEqual:
            return valueLeft  >= valueRight;
        case ComparisonOperators.LessThanOrEqual:
            return valueLeft  <= valueRight;
        case ComparisonOperators.NotEqual:
            return valueLeft !== valueRight;
    }
}